var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2653 9.57238C13.275 8.88245 13.4737 8.20598 13.8431 7.6059C14.2125 7.00583 14.7405 6.50165 15.3779 6.14028C14.973 5.60699 14.4387 5.16812 13.8176 4.85851C13.1965 4.54891 12.5057 4.3771 11.8 4.35674C10.2946 4.21104 8.83518 5.18734 8.06804 5.18734C7.28608 5.18734 6.10498 4.37121 4.83313 4.39534C4.01046 4.41984 3.20871 4.64042 2.50598 5.03559C1.80326 5.43075 1.22353 5.98702 0.82329 6.6502C-0.910441 9.418 0.382769 13.4858 2.04357 15.7231C2.87451 16.8186 3.84563 18.0423 5.11634 17.9989C6.3598 17.9514 6.8242 17.2678 8.32516 17.2678C9.81219 17.2678 10.2479 17.9989 11.5444 17.9714C12.8787 17.9514 13.7193 16.8709 14.5211 15.765C15.1182 14.9844 15.5776 14.1217 15.8824 13.2088C15.1072 12.9064 14.4456 12.4004 13.9803 11.7538C13.5149 11.1071 13.2662 10.3485 13.2653 9.57238Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8167 2.88536C11.5442 2.08008 11.9026 1.04502 11.8159 0C10.7044 0.10764 9.6777 0.597449 8.94036 1.37183C8.57985 1.75014 8.30374 2.19026 8.12781 2.66701C7.95188 3.14377 7.87959 3.64783 7.91505 4.15037C8.47099 4.15564 9.02097 4.04454 9.52359 3.82542C10.0262 3.6063 10.4683 3.28487 10.8167 2.88536Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d924696afd2b4a10883e9a8c05f80b3b.svg";
export { ForwardRef as ReactComponent };